export default function wrapAmpersand(string = "") {
  return string.replace?.(/&/g, '<span class="font-cursive">&</span>')
}
